<template>
  <span
    ref="me"
    class="flex flex-row items-center"
  >
    <img
      v-if="happiness.level === 1"
      :src="`${require('@/assets/images/happiness1.png')}`"
      alt=""
      class="w-6 h-6"
    >
    <img
      v-else-if="happiness.level === 2"
      :src="`${require('@/assets/images/happiness2.png')}`"
      alt=""
      class="w-6 h-6"
    >
    <img
      v-else-if="happiness.level === 3"
      :src="`${require('@/assets/images/happiness3.png')}`"
      alt=""
      class="w-6 h-6"
    >
    <img
      v-else
      :src="`${require('@/assets/images/happiness0.png')}`"
      alt=""
      class="w-6 h-6"
    >
    <span class="ml-1">
      Culture: {{ happiness.value }} <span v-if="happiness.level < 3">({{
        happiness.required
      }} required for the next level)</span><span v-else>(Maxed)</span>
    </span>
  </span>
</template>

<script>
import {useLayoutStore} from '@/roc/stores/LayoutStore';
import {computed, ref, watch} from 'vue';

export default {
  props: {
    buildingId: {
      type: String,
      required: true
    },
  },
  setup (props) {
    const lytStore = useLayoutStore();
    const happiness = ref({
      value: 0,
      level: 0,
      required: 0,
    });

    watch(() => lytStore.buildings[props.buildingId].happiness, (val) => {
      happiness.value = {
        ...val,
      };
    }, {deep: true, immediate: true});

    return {
      happiness: computed(() => happiness.value),
    };
  },
};
</script>
